const cdn = "https://cdn.shopify.com/s/files/1/0236/5073/t/188";

const rdIdMap = {
  decks: "decks",
  wheels: "wheel",
  trucks: "trucks",
  "trucks-venture" :"trucks-venture",
  "trucks-thunder": "trucks-thunder",
  "griptape": "grip",
};

const defaultTextures = {
  decks: {
    texture: {
      color:
        `${cdn}/assets/blank_deck.jpg`,
      roughness:
        `${cdn}/assets/general_imperfections.jpg`,
    },
  },
  wheel: {
    roughness: 0.7,
    texture: {
      color:
        `${cdn}/assets/blank_wheel.jpg`,
    },
  },
  grip: {
    texture: {
      color:
        `${cdn}/assets/blank_grip.jpg`,
      roughness:
        `${cdn}/assets/grip_imperfections.jpg`,
    },
  },
  trucks: {
    texture: {
      color:
        `${cdn}/assets/blank_trucks.jpg`,
    },
  },
};

class RDController {
  constructor() {
    this.accordionSelectors = null;
    this.mount();
    this.active = "decks";
    this.openAccordions = [];
    this.trickToggle;
    this.trickSelectors;
    this.trickModeActive = false;
  }

  mount() {
    this.accordionSelectors = document.querySelectorAll(
      ".customizable-product__accordion-container"
    );
    this.trickSelectors = document.querySelectorAll('.js-do-trick');
    this.trickToggle = document.querySelector('.js-toggle-trick-mode');
    this.addEventListeners();
  }

  addTextureToActivePart(handle) {
    if (!window.RDTextureLookup.hasOwnProperty(handle)) return;
    const {src, id} = window.RDTextureLookup[handle];

    this.checkForDifferentTrucks(id);
    this.checkForDifferentDecks(id);

    window.RideDesigner.updateMaterial(id, {
      texture: {
        color: src,
      },
    });
  }

  handleCameraToLastOpenedAccordion() {
    const lastOpenedAccordion =
      this.openAccordions[this.openAccordions.length - 1];
    const shouldFloat = lastOpenedAccordion === "decks" || typeof lastOpenedAccordion === "undefined";
    
    window.RideDesigner.setCamera(lastOpenedAccordion);
    window.RideDesigner.setFloating(shouldFloat);
    this.active = lastOpenedAccordion;
    this.toggleTrickMode(false, shouldFloat);
  }

  updateListOfOpenAccordionItems() {
    if (!this.accordionSelectors || this.accordionSelectors.length === 0)
      return;
    // TODO: This timeout patches a race condition, where it checks for active before it's added/removed
    setTimeout(() => {
      this.accordionSelectors.forEach((item) => {
        const isOpen = item.classList.contains("active");
        const handle = rdIdMap[item.getAttribute("data-accordion-for-modal")];
        if (!handle) return;

        if (isOpen) {
          if (!this.openAccordions.includes(handle))
            this.openAccordions.push(handle);
        } else {
          this.openAccordions = this.openAccordions.filter(
            (item) => item !== handle
          );
        }
      });
      this.handleCameraToLastOpenedAccordion();
    }, 200);
  }

  addEventListeners() {
    if (!this.accordionSelectors || this.accordionSelectors.length === 0)
      return;
    this.accordionSelectors.forEach((item) => {
      item.addEventListener("click", () =>
        this.updateListOfOpenAccordionItems()
      );
    });

    this.trickToggle.addEventListener('click', () => this.toggleTrickMode());

    this.trickSelectors.forEach((item) => {
        const trickId = item.getAttribute('data-trick-id');
        item.addEventListener('click', () => this.doTrick(trickId));
    });
  }

  setDefaultTexture(_id) {
    const id = rdIdMap[_id];
    this.checkForDifferentTrucks(id);
    this.checkForDifferentDecks(id);
    window.RideDesigner.updateMaterial(id, defaultTextures[id]);
  }

  checkForDifferentTrucks(id) {
    const relatedTruckHandles = ['trucks', 'trucks-venture', 'trucks-thunder'];
    if (relatedTruckHandles.includes(id)) {
      relatedTruckHandles.forEach((handle) => {
        window.RideDesigner.togglePart(handle, handle === id);
      });
    }
  }

  checkForDifferentDecks(id) {
    const relatedDeckHandles = ['decks', 'decks-retro'];
    if (relatedDeckHandles.includes(id)) {
      relatedDeckHandles.forEach((handle) => {
        window.RideDesigner.togglePart(handle, handle === id);
      });
      window.RideDesigner.togglePart('grip', id !== 'decks-retro');
    }
  }

  doTrick(id) {
    window.RideDesigner.doTrick(id);
  }

  toggleTrickMode(force, forceFloat) {
    const newActiveState = typeof force !== "undefined" ? force : !this.trickModeActive;
    const newFloatState = newActiveState ? false : this.active === "decks";
    const cameraControls = document.querySelector('.ride-designer-camera-controls-container');
    const competitionButton = document.querySelector('.js-open-comp');


    if (newActiveState) {
      cameraControls.classList.add('hidden');
      competitionButton && competitionButton.classList.add('hidden');
    } else {
      cameraControls.classList.remove('hidden');
      competitionButton && competitionButton.classList.remove('hidden');
    }

    window.RideDesigner.setTrickMode(newActiveState);
    window.RideDesigner.setFloating(typeof forceFloat !== "undefined" ? forceFloat : newFloatState);

    this.trickToggle.innerHTML = newActiveState ? 'x' : 'Do some tricks';
    
    this.trickSelectors.forEach((item) => {
        item.classList.toggle('active', newActiveState);
    });

    this.trickModeActive = newActiveState;
  }
}

window.onload = () => (window.RDController = new RDController());

const cameraControls = document.querySelectorAll(".js-rd-camera-control");
cameraControls.forEach((control) => {
  control.addEventListener("click", () => {
    const camera = control.getAttribute("data-camera");
    window.RideDesigner.setCamera(camera);
    window.RideDesigner.setFloating(camera === "deck");
  });
});

$('.js-open-comp').on("click", function() {
  $('[data-remodal-id=sharecustom]').remodal().open();
});

$('.js-take-social-photo').on("click", function() {
  $('[data-remodal-id=sharecustom]').remodal().close();
  window.RideDesigner.takeSocialPhoto();
})

// const debug = document.getElementById("debug");
// const ctx = debug.getContext("2d");
// const newImgUrl = "https://cdn.accentuate.io/6957125304363/1665348176736/real-ishod-venus-deck.jpg?v=1665348176736";
// const img = new Image();
// img.src = newImgUrl;
// img.onload = () => {
//   ctx.drawImage(img, 0, 0);
// }